import React from 'react';
import PropTypes from 'prop-types';
import { LocaleService } from '@sm360/widget-commons-core-services';
import { Quote, Vehicle } from '@sm360/widget-commons-vehicle';
import VehicleImage from 'commons-garage/components/GarageVehicle/VehicleImageWrapper/VehicleImage/VehicleImage.jsx';
import 'commons-garage/components/GarageVehicle/VehicleImageWrapper/VehicleImageWrapper.scss';

const VehicleImageWrapper = ({ quote, vehicle, isMultiDealerGarage }) => {
    const vehicleImageClasses =
        quote.isQuoteInPending() || vehicle.isAvailable()
            ? 'vehicle-wrapper-image'
            : 'vehicle-wrapper-image unavailable';

    const vehicleConditionClasses = [
        'vehicle-wrapper-image__condition',
        'has-secondary-background',
        'sr-text',
        'is-small',
        'is-centered',
    ];
    return (
        <div className={vehicleImageClasses}>
            <div className="vehicle-wrapper-image__crops">
                <VehicleImage quote={quote} vehicle={vehicle} isMultiDealerGarage={isMultiDealerGarage} />
            </div>
            <p className={vehicleConditionClasses.join(' ')}>{quote.getVehicleConditionType()}</p>
            {vehicle.getIsVehicleNew() &&
                quote.isQuoteVehicleFromInventory() && (
                    <p className="vehicle-wrapper-image__in-stock sr-text is-small is-bold is-centered">
                        {LocaleService.t('GARAGE.VEHICLE_STATUS.IN_STOCK')}
                    </p>
                )}
        </div>
    );
};

VehicleImageWrapper.propTypes = {
    quote: PropTypes.instanceOf(Quote.QuoteModelV25).isRequired,
    vehicle: PropTypes.instanceOf(Vehicle.VehicleModel).isRequired,
    isMultiDealerGarage: PropTypes.bool.isRequired,
};

VehicleImageWrapper.displayName = 'VehicleImageWrapper';

export default VehicleImageWrapper;
